<template>
	<div
		:class="[
			'checkbox',
			{'checkbox--with-description': checkbox.description},
			{'is-checked': checkbox.isChecked},
			{'is-disabled': checkbox.isDisabled}
		]"
	>
		<div class="checkbox__sign"></div>
		<div class="checkbox__txt">{{ checkbox.txt }}</div>
		<div v-if="showDescription && checkbox.description" class="checkbox__description">{{ checkbox.description }}</div>
	</div>
</template>

<script>
	export default {
		props: {
			checkbox: {
				type: Object,
				required: true
			},
			showDescription: {
				type: Boolean,
				default: true
			}
		}
	};
</script>

<style lang="scss">
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";

	.checkbox {
		$b: &;

		padding-top: 4px;
		padding-left: 38px;
		position: relative;
		min-height: 25px;
		cursor: pointer;

		&__sign {
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 25px;
			height: 25px;
			border-radius: 50%;
			border: 1px solid $col-neutral--3;
			background-color: $col-neutral--0;
			overflow: hidden;
			transition-property: background-color, border-color;
			transition-duration: $ttime;

			&::before {
				content: '';
				display: block;
				position: absolute;
				width: 9px;
				height: 3px;
				border-left: 3px solid $col-neutral--0;
				border-bottom: 3px solid $col-neutral--0;
				top: 45%;
				left: 110%;
				transform: translateX(-50%) translateY(-50%) rotate(-45deg);
				transition: left $ttime;

				#{$b}.is-checked & {
					left: 50%;
				}
			}

			#{$b}:hover & {
				background-color: $col-neutral--1;
			}

			#{$b}.is-invalid & {
				border-color: $col-negative--1;
			}

			#{$b}.is-checked & {
				background-color: $col-positive--1;
				border-color: $col-positive--1;
			}
		}

		&__txt {
			color: $col-neutral--8;
			font-weight: 600;
			font-size: 14px;
			line-height: 16px;
		}

		&__description {
			font-size: 14px;
			line-height: 18px;
			color: $col-neutral--6;
		}

		&--with-description {
			padding-top: 0;
		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: $col-neutral--0;
			opacity: 0;
			transition: opacity $ttime;

			#{$b}.is-disabled & {
				opacity: 0.6;
			}
		}

		&.is-disabled {
			pointer-events: none;
		}

		&.not-clickable {
			cursor: default;
		}

		@include mq(largeMobile) {
			&__txt {
				font-size: 16px;
				line-height: 18px;
			}

			&__description {
				font-size: 16px;
				line-height: 20px;
			}
		}
	}
</style>